import Spinner from '@features/ui-atoms/components/Spinner';
import { BodyWrapper } from '@features/ui-layout/components/ResponsiveWrappers';
import Sidebar from '@features/ui-layout/components/Sidebar';
import { useCurrentUser } from '@features/user/hooks/useAuth';
import { useGlobalNotifications } from '@root/src/hooks/useGlobalNotifications';
import { useUnreadTabTitle } from '@root/src/hooks/useUnreadTabTitle';
import { styled } from '@mui/joy';
import { ReactNode } from 'react';

interface LayoutLoggedinProps {
  children: ReactNode;
}

export const LayoutLoggedin = ({ children }: LayoutLoggedinProps) => {
  const { data: currentUser, isLoading, error } = useCurrentUser();

  // Set up global notifications for authenticated users
  useGlobalNotifications();
  useUnreadTabTitle();

  // If there's an error or no user data, show loading (middleware will handle redirect)
  if (error || !currentUser || isLoading) {
    return (
      <BodyWrapper>
        <SpinnerContainer>
          <Spinner size="lg" />
        </SpinnerContainer>
      </BodyWrapper>
    );
  }

  return (
    <BodyWrapper>
      <Sidebar />
      <MainContent>{children}</MainContent>
    </BodyWrapper>
  );
};

const SpinnerContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  gap: 24px;
`;

const MainContent = styled('div')`
  margin-left: var(--width-sidebar);
  width: calc(100% - var(--width-sidebar));
  height: 100vh;
  min-height: 100vh;
  background-color: var(--joy-palette-grey1);
  overflow-y: auto;
  overflow-x: hidden;
`;
